import { Popover, StyleguideAiIcon } from '@lokalise/louis';

import { PopoverText } from '../../StyleGuideRow/style';
import { IconContainer, InProgressText, SyncButtonContainer } from '../styles';

export const InProgressStateButton = () => (
    <Popover
        content={
            <PopoverText>
                Sync with AI in progress. It might take a while. Please check back later for updates.
            </PopoverText>
        }
        triggerEvent="hover"
        withArrow
    >
        <SyncButtonContainer $inProgress aria-label="Sync In Progress">
            <IconContainer align="center" justify="center">
                <StyleguideAiIcon size="16px" />
            </IconContainer>
            <InProgressText>
                In progress
                <span>.</span>
                <span>.</span>
                <span>.</span>
            </InProgressText>
        </SyncButtonContainer>
    </Popover>
);

export default InProgressStateButton;
